<span>
  {{ value | translate }}
</span>
